




























































// eslint-disable-next-line @typescript-eslint/no-var-requires
const ja = require('vuejs-datepicker/dist/locale').ja;
import { Vue, Component, Watch } from 'vue-property-decorator';
import { dayjs, DT_FORMAT_INPUT } from '../../../src_server/common/momentExtends';
import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';
import { MessageDialog } from '../../utils/MessageDialog';
import { LessonsService } from '../../biz/remote/LessonsService';
import { Session } from '../../utils/Session';
import LessonStateCard from './LessonStateCard.vue';
import { routeHelper } from '../../utils/routeHelper';

@Component({
  components: {
    LessonStateCard,
  },
})
export default class StudentLessonStatePage extends Vue {
  private rows: LessonDTO[] = [];
  private search = '';
  private selectedRow: LessonDTO = new LessonDTO();
  private from = dayjs().format('YYYY-MM-DD');
  private to = dayjs().add(1, 'month').add(-1, 'date').format('YYYY-MM-DD');
  private loading = false;
  get ja() {
    return ja;
  }
  get model() {
    const recent = this.rows.filter((row) => {
      console.log('diff  ', row.lessons.start_dt, dayjs(row.lessons.start_dt).diff(dayjs(), 'd'));
      return dayjs(row.lessons.start_dt).diff(dayjs(), 'd') > 0;
    })[0];
    console.log('recent', recent);
    if (recent) {
      recent.isRecent = true;
    }

    return this.rows.sort((a, b) => {
      // asc order
      if (!a.lessons?.start_dt || !b.lessons?.start_dt) return 0;
      if (a.lessons.start_dt >= b.lessons.start_dt) return -1;
      if (a.lessons?.start_dt < b.lessons?.start_dt) return 1;
      else return 0;
    });
  }

  @Watch('from')
  @Watch('to')
  async loadData() {
    this.loading = true;
    // const month = dayjs(this.month);
    // const from = from
    // const to = month.endOf('month').format(DT_FORMAT_INPUT);

    const biz = new LessonsService();
    const response = await biz.getLessonsStateForStudent(Session.getSessionUserId(), this.from, this.to, Session.getSessionBuildingId());
    if (response.hasError) {
      await MessageDialog.alert(response.errorDescription);
      this.loading = false;
      return;
    }
    this.rows = response.data;
    this.loading = false;
  }

  async created() {
    await this.loadData();
  }

  deleteRow(class_id: number) {
    const index = this.rows.findIndex((i) => i.lessons.class_id === class_id);
    this.rows.splice(index, 1);
  }

  toCalendarView() {
    routeHelper(this, 'StudentLessonStateCalendarPage');
  }
}
